import { render, staticRenderFns } from "./byageDiversity.vue?vue&type=template&id=85f54168&scoped=true&"
import script from "./byageDiversity.vue?vue&type=script&lang=js&"
export * from "./byageDiversity.vue?vue&type=script&lang=js&"
import style0 from "./byageDiversity.vue?vue&type=style&index=0&id=85f54168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f54168",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
